import React, { useState, useEffect } from 'react';
import axios from 'axios';

const DeleteCause = () => {
  const [causes, setCauses] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    const fetchCauses = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_REQUESTING_API}/api/causes`
        );
        setCauses(response.data);
      } catch (error) {
        console.error('Error fetching causes:', error);
      }
    };
    fetchCauses();
  }, []);

  const filteredCauses = causes.filter(cause =>
    cause.donationFor.toLowerCase().includes(searchTerm.toLowerCase()) ||
    cause.description.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm('Are you sure you want to delete this cause?');
    if (!confirmDelete) return;

    try {
      await axios.delete(
        `${process.env.REACT_APP_REQUESTING_API}/api/causes/${id}`
      );
      setCauses(causes.filter(cause => cause._id !== id));
      alert('Cause successfully deleted');
    } catch (error) {
      console.error('Failed to delete the cause:', error);
      alert('Failed to delete the cause');
    }
  };

  return (
    <div className="p-6 max-w-7xl mx-auto">
      {/* Header */}
      <h1 className="text-3xl font-bold text-gray-800 mb-6">
        Search & Delete Causes
      </h1>

      {/* Search Bar */}
      <div className="mb-6">
        <input
          type="text"
          placeholder="Search by donation name or description..."
          className="w-full md:w-[40%] px-4 py-3 rounded-xl
                     border border-gray-300
                     focus:outline-none focus:ring-2 focus:ring-gray-400
                     shadow-sm"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      {searchTerm && filteredCauses.length === 0 && (
        <p className="text-gray-500">No causes found.</p>
      )}

      {searchTerm && (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {filteredCauses.map((cause) => (
            <div
              key={cause._id}
              className="bg-white rounded-2xl shadow-md
                         hover:shadow-xl transition-shadow duration-300
                         border border-gray-100 overflow-hidden"
            >
              {/* Image */}
              {cause.images && cause.images.length > 0 && (
                <img
                  src={`data:image/jpeg;base64,${cause.images[0]}`}
                  alt={cause.cause}
                  className="w-full h-44 object-cover"
                />
              )}

              {/* Content */}
              <div className="p-4 space-y-2">
                <p className="text-sm text-gray-500 uppercase tracking-wide">
                  Cause
                </p>
                <h3 className="text-lg font-semibold text-gray-800">
                  {cause.cause}
                </h3>

                <p className="text-sm text-gray-500 uppercase tracking-wide mt-2">
                  Donation For
                </p>
                <p className="text-gray-700 font-medium">
                  {cause.donationFor}
                </p>

                {/* Delete Button */}
                <button
                  onClick={() => handleDelete(cause._id)}
                  className="mt-4 w-full py-2.5 rounded-xl
                             bg-red-50 text-red-600 font-semibold
                             hover:bg-red-100 hover:text-red-700
                             transition-colors duration-200
                             border border-red-200"
                >
                  Delete Cause
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default DeleteCause;





// working 16/12/25

// import React, { useState, useEffect } from 'react';
// import axios from 'axios';

// const DeleteCause = () => {
//   const [causes, setCauses] = useState([]);
//   const [searchTerm, setSearchTerm] = useState('');

//   // Fetch all causes when the component mounts
//   useEffect(() => {
//     const fetchCauses = async () => {
//       try {
//         const response = await axios.get(`${process.env.REACT_APP_REQUESTING_API}/api/causes`);
//         setCauses(response.data);
//       } catch (error) {
//         console.error('Error fetching causes:', error);
//       }
//     };

//     fetchCauses();
//   }, []);

//   // Function to filter causes based on the search term
//   const filteredCauses = causes.filter(cause =>
//     cause.donationFor.toLowerCase().includes(searchTerm.toLowerCase()) ||
//     cause.description.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   // Function to delete a cause
//   const handleDelete = async (id) => {
//     const confirmDelete = window.confirm('Are you sure you want to delete this cause?');
//     if (!confirmDelete) return;

//     try {
//       const response = await axios.delete(`${process.env.REACT_APP_REQUESTING_API}/api/causes/${id}`);
//       console.log('Delete response:', response);
//       setCauses(causes.filter(cause => cause._id !== id)); // Remove the deleted cause from state
//       alert('Cause successfully deleted');
//     } catch (error) {
//       console.error('Failed to delete the cause:', error);
//       alert('Failed to delete the cause');
//     }
//   };

//   return (
//     <div className="p-4">
//       <h1 className="text-2xl font-bold mb-4">Search and Delete Causes</h1>

//       {/* Live Search Bar */}
//       <div className="mb-4">
//         <input
//           type="text"
//           placeholder="Search by name or description"
//           className="p-2 w-[40%] border-2 rounded-full"
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)} // Update the search term live
//         />
//       </div>

//       {/* Show "No causes found" if no results match the search */}
//       {searchTerm && filteredCauses.length === 0 && <p>No causes found</p>}

//       {/* Only show causes if search term is not empty */}
//       {searchTerm && (
//         <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-4">
//           {filteredCauses.map((cause) => (
//             <div key={cause._id} className="border rounded-lg p-4 shadow-lg">
//               {cause.images && cause.images.length > 0 && (
//                 <img
//                   src={`data:image/jpeg;base64,${cause.images[0]}`}
//                   alt={cause.name}
//                   className="w-full h-48 object-cover mb-4"
//                 />
//               )}
//               <h3 className="text-lg "><span className='font-semibold'>  Cause:</span> {cause.cause}</h3>
//               <h3 className="text-lg "><span className='font-semibold'> Donation For:</span>  {cause.donationFor}</h3>

              
//               {/* <p className="text-gray-700">{cause.description}</p> */}
//               <button
//                 onClick={() => handleDelete(cause._id)}
//                 className="mt-4 bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded w-full"
//               >
//                 Delete
//               </button>
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// export default DeleteCause;
